import { IconButton } from '@mui/material'
import { Help as HelpIcon } from '@mui/icons-material'
import React, { useState } from 'react'
import { HelpModal } from './HelpModal'
import { localStorageKey } from '../../../utils/localStorageKey'

export const HelpButton: React.FC<React.PropsWithChildren<unknown>> = () => {
  const [isOpen, setIsOpen] = useState(
    !localStorage.getItem(localStorageKey.protocolHelpPage)
  )

  const handleOpen = () => {
    setIsOpen(true)
  }

  const handleClose = () => {
    localStorage.setItem(localStorageKey.protocolHelpPage, 'viewed')
    setIsOpen(false)
  }

  return (
    <>
      <IconButton color="primary" onClick={handleOpen} size="large">
        <HelpIcon fontSize="large" />
      </IconButton>
      {isOpen && <HelpModal isOpen={isOpen} onClose={handleClose} />}
    </>
  )
}
